import React, { useEffect, useState } from "react";
import AdminSectionHeader from "@/components/admin/AdminSectionHeader";
import AdminTable from "@/components/admin/AdminTable";
import { api, formatApiError } from "@/lib/api";

export default function AdminAuditLogs() {
    const [logs, setLogs] = useState([]);
    const [error, setError] = useState("");
    useEffect(() => {
        api.get("/admin/audit-logs", { params: { limit: 200 } })
            .then(({ data }) => setLogs(data))
            .catch((e) => setError(formatApiError(e)));
    }, []);
    return (
        <>
            <AdminSectionHeader title="Audit logs" description="Traçabilité des actions admin." />
            {error && <div className="mb-4 rounded-lg border border-md-danger/30 bg-md-danger/10 px-4 py-2 text-sm text-md-danger">{error}</div>}
            <AdminTable
                columns={[
                    { key: "created_at", label: "Date", render: (r) => r.created_at?.replace("T", " ").split(".")[0] },
                    { key: "action", label: "Action" },
                    { key: "target_type", label: "Cible", render: (r) => r.target_type || "—" },
                    { key: "target_id", label: "ID cible", render: (r) => r.target_id || "—" },
                    { key: "ip", label: "IP", render: (r) => r.ip || "—" },
                ]}
                rows={logs}
                emptyLabel="Aucune action enregistrée."
            />
        </>
    );
}
